import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ImageLight from "../assets/img/Login.png";
import { useUserContext } from "../context/UserContext";
import { ASSETS_LOCATION } from "../utils/constants";
import { Avatar, Dropdown, DropdownItem, Button } from "@windmill/react-ui";
import { useTranslation } from "react-i18next";

function ChooseBrand() {
  const history = useHistory();
  const { t } = useTranslation();

  const {
    userData,
    fetchUserAssociatedBrand,
    brandData,
    handleBrandSelection,
  } = useUserContext();
  const [openBrandMenu, setOpenBrandMenu] = useState<boolean>(false);
  const [localBrand, setLocalBrand] = useState<Brand>(brandData[0]);

  const handleBrandClick = () => {
    setOpenBrandMenu(true);
  };

  useEffect(() => {
    // const userId = "66de9dbd63f6897640ba8b67";
    const userId = userData?.id;
    if (userId) {
      fetchUserAssociatedBrand(userId);
    }
  }, [userData]);

  return (
    <div className="flex items-center min-h-screen p-6 bg-gray-50 dark:bg-gray-900">
      <div className="flex-1 h-full max-w-4xl mx-auto overflow-hidden bg-white rounded-lg shadow-xl dark:bg-gray-800">
        <div className="flex flex-col overflow-y-auto md:flex-row">
          <div className="h-32 md:h-auto md:w-1/2">
            <img
              className="object-cover w-[400px] h-full"
              src={ImageLight}
              alt="Office"
            />
          </div>
          <main className="flex items-center justify-center p-6 sm:p-12 md:w-1/2">
            <div className="w-full">
              <h1 className="mb-4 text-xl font-semibold text-gray-700 dark:text-gray-200">
                {t("chooseBrand.title")}
              </h1>
              <div className="flex justify-center flex-1 w-full">
                <div className="relative w-full focus-within:text-purple-500">
                  <button
                    className="focus:shadow-outline-purple focus:outline-none border border-solid border-black dark:border-white flex justify-between items-center py-1 px-3 rounded-md w-full"
                    onClick={handleBrandClick}
                    aria-label="brand"
                    aria-haspopup="true"
                  >
                    <div className="rounded-full focus:shadow-outline-purple focus:outline-none w-10 h-10 bg-black flex justify-center items-center">
                      <h2 className="text-[#fff] text-2xl font-semibold leading-normal">
                        {localBrand?.brandName?.charAt(0).toUpperCase() ||
                          "T"}
                      </h2>
                    </div>
                    <p className="text-black dark:text-white">
                      {localBrand?.brandName}
                    </p>
                  </button>
                  <Dropdown
                    align="right"
                    isOpen={openBrandMenu}
                    onClose={() => {}}
                  >
                    {brandData.map((brand, index) => (
                      <DropdownItem
                        key={brand.brandId}
                        onClick={() => {
                          setLocalBrand(brand)
                          setOpenBrandMenu(false);
                        }}
                      >
                        <div className="rounded-full focus:shadow-outline-purple focus:outline-none w-10 h-10 bg-black flex justify-center items-center">
                          <h2 className="text-[#fff] text-2xl font-semibold leading-normal">
                            {brand?.brandName?.charAt(0).toUpperCase() || "T"}
                          </h2>
                        </div>
                        <p>{brand.brandName}</p>
                      </DropdownItem>
                    ))}
                  </Dropdown>
                </div>
              </div>
              <Button
                type="submit"
                className="mt-4"
                block
                onClick={() => {
                  handleBrandSelection(localBrand); 
                  history.push("/app/orders");
                }}
              >
                {t("chooseBrand.submit")}
              </Button>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default ChooseBrand;
